module.exports = __webpack_public_path__ + "img/home-screen.fd6a0c8d.png";